export class ToastMessage {
    constructor(label, type, timeout, actionLibelle) {
        this.label = label;
        this.type = type;
        this.timeout = timeout;
        this.actionLibelle = actionLibelle;
    }
}
